// Copied from transition-web/src/libs/SignInHelper.ts
// TODO: Adapt for new types

import { SignInState, SignInSteps, PreferredLoginMethod } from '../../../pure-js/types/SignInTypes'
import { State } from '../hooks/useAppState'

export const DEFAULT_SIGN_IN_STATE: SignInState = {
  data: {
    email: ''
  },
  preferredLoginMethod: PreferredLoginMethod.MAIL,
  step: SignInSteps.LANDING
}

export interface SignInPageProps {
  onLogin?: (state: State) => void
}
